import { useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import signUpToNowPay from "../assets/icons/signUpStep.svg"
import userStep from "../assets/icons/UserStepIcon.svg"
import teamStep from "../assets/icons/calenderStep.svg"
import moneyStep from "../assets/icons/cash-icon.svg"
import completeStep from "../assets/icons/service-icon.svg"
import GetInTouchModal from "./GetInTouchModal"
import { fadeIn, fadeUp, staggerContainer } from "../lib/motion"


export function PartnerStepsSection() {
  const { translation: t, lang } = useLanguage()
  const [isModalOpen, setIsModalOpen] = useState(false);

  const steps = [
    {
      number: 1,
      text: t.step1,
      icon: <img src={signUpToNowPay} alt="signUpToNowPay" />,
    },
    {
      number: 2,
      text: t.step2,
      icon: <img src={userStep} alt="userStep" />,
    },
    {
      number: 3,
      text: t.step3,
      icon: <img src={teamStep} alt="teamStep" />,
    },
    {
      number: 4,
      text: t.step4,
      icon: <img src={completeStep} alt="completeStep" />,
    },
    {
      number: 5,
      text: t.step5,
      icon: <img src={moneyStep} alt="moneyStep" />,
    },
  ]

  return (
    <>
      <AnimatePresence>
        {isModalOpen && <GetInTouchModal setIsModalOpen={setIsModalOpen} formType="get-in-touch" />}
      </AnimatePresence>
      <motion.section
        variants={fadeIn}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        <div className="container mx-auto">
        <motion.h2
          className="text-[1.75rem] md:text-4xl lg:text-[2.5rem] font-bold text-primary text-center mx-2 md:mx-40 lg:mx-0 mb-9 md:mb-12 px-4"
          variants={fadeUp}
        >
          {t.partnerSteps}
        </motion.h2>

        {/* Desktop View - Horizontal */}
        <div className="hidden lg:block max-w-6xl mx-auto">
          <div className="relative px-8">
            {/* Steps Container */}
            <motion.div className="flex justify-center gap-[3.25rem]" variants={staggerContainer(0.12, 0.08)}>
              {steps.map((step, index) => (
                <motion.div
                  key={step.number}
                  className="staggered-item"
                  style={{ "--stagger-index": index } as React.CSSProperties}
                  variants={fadeUp}
                >
                  <div className="flex flex-col items-center w-[9.75rem] gap-3.5 hover-lift">
                    <div className="w-16 h-16 flex items-center justify-center hover-scale">
                      {step.icon}
                    </div>
                    <span className="text-[2rem] font-bold text-softGreen font-arabic">
                      {step.number}
                    </span>
                    <p className="text-primary text-center text-base lg:text-[1.375rem] !leading-[134%] lg:leading-relaxed">
                      {step.text}
                    </p>
                  </div>
                </motion.div>
              ))}
              {[1, 2, 3, 4].map((_, index) => {
                const leftPosition = `calc(14rem + ${index * 13}rem)`;
                return (
                  <div 
                    key={index} 
                    className="absolute hidden xl:flex items-center gap-1 pt-8"
                    style={{ left: leftPosition }}
                  >
                    {[...Array(11)].map((_, i) => (
                      <div key={i} className={`${i === 0 || i === 10 ? "w-0.5 h-1" : "w-1 h-1"} bg-softGreen`}></div>
                    ))}
                  </div>
                );
              })}
            </motion.div>
          </div>

          {/* Contact Button */}
          <div className="flex justify-center mt-9 md:mt-12">
            <motion.button 
              onClick={() => setIsModalOpen(true)}
              className={`h-11 lg:h-[3.625rem] inline-flex items-center justify-center bg-softGreen text-white px-[3.75rem] py-3 md:py-4 rounded-full font-semibold text-base md:text-lg lg:text-xl xl:text-[1.375rem] hover:bg-[#66B57C] transition-colors hover-glow leading-normal ${lang === "ar" ? "font-arabic" : ""}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {t.getInTouch}
            </motion.button>
          </div>
        </div>

        {/* Mobile View - Vertical */}
        <div className="lg:hidden max-w-md mx-auto px-9">
          <div className="relative">

            {steps.map((step, index) => (
              <motion.div
                key={step.number}
                className="staggered-item font-arabic"
                style={{ "--stagger-index": index } as React.CSSProperties}
                variants={fadeUp}
              >
                <div className="relative flex items-center gap-3.5 mb-6 hover-lift">
                  <div className="w-9 h-9 flex items-center justify-center shrink-0 hover-scale">
                    {step.icon}
                  </div>
                  <div className="text-2xl font-bold text-softGreen">
                    {step.number}
                  </div>
                  <p className="text-primary text-base md:text-lg !leading-[134%] lg:leading-relaxed">
                    {step.text}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Contact Button */}
          <div className="flex justify-center mt-9 md:mt-12">
            <motion.button
              onClick={() => setIsModalOpen(true)}
              className={`h-11 lg:h-[3.625rem] inline-flex items-center justify-center bg-softGreen text-white px-[3.75rem] md:px-10 py-3 rounded-full font-semibold text-lg shadow-md hover:bg-[#66B57C] transition-colors hover-glow leading-normal ${lang === "ar" ? "font-arabic" : ""}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {t.getInTouch}
            </motion.button>
          </div>

        </div>
        </div>
      </motion.section>
    </>
  )
}
